import script from "./LiveItemSquare.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiveItemSquare.vue?vue&type=script&setup=true&lang=ts"

import "./LiveItemSquare.vue?vue&type=style&index=0&id=1e7b3eab&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e7b3eab"]])

export default __exports__